import { NavLink, useLocation } from 'react-router-dom';

const NavItem = ({ icon, ReactIcon, label, to, activePaths = [], exactActivePaths = [], unreadCount = 0 }) => {
    const location = useLocation();
    const currentPath = location.hash ? location.hash.replace(/^#/, '') : location.pathname; // Handle hash router

        const isActive = activePaths.length || exactActivePaths.length
                ? exactActivePaths.some(path => currentPath === path) ||
                    activePaths.some(path => currentPath.startsWith(path))
                : currentPath === to;

    return (
        <NavLink
            to={to}
            className={`relative flex items-center space-x-3 py-3 px-4 rounded-lg transition-all duration-200 
                ${isActive
                    ? "bg-[#327691] text-white"
                    : "text-black dark:text-white hover:bg-gray-100 dark:hover:bg-white/10 opacity-80"
                }`}
        >
            {ReactIcon ? (
                <ReactIcon className={`w-5 h-5 ${isActive ? 'text-white' : 'text-black dark:text-white'}`} />
            ) : (
                <img src={icon} className={`w-5 h-5 grayscale brightness-0 dark:invert ${isActive ? 'invert' : ''}`} alt={`${label} icon`} />
            )}
            <span className="text-base font-medium">{label}</span>
            {/* 🔥 UNREAD BADGE */}
            {unreadCount > 0 && (
                <span className="absolute top-0 left-0 bg-red-500 text-white text-[10px] min-w-[18px] h-[18px] flex items-center justify-center rounded-full px-1">
                    {unreadCount > 99 ? "99+" : unreadCount}
                </span>
            )}
        </NavLink>
    );
};

export default NavItem;
